import React from 'react'

import { Button, classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, func } from 'prop-types'

function Footer({
  isSignup, canSubmit, onSwitchMode,
}) {
  return (
    <div className={classnames(
      'ai-sign-in-modal__footer',
      isSignup ? 'ai-sign-in-modal__footer--signup' : 'ai-sign-in-modal__footer--login'
    )}
    >
      <Button
        type="primary"
        size="medium"
        actionType="submit"
        disabled={!canSubmit}
        customClass="ai-sign-in-modal__submit"
      >
        Continue
      </Button>

      <p className="ai-sign-in-modal__switch cgt-body-base">
        {isSignup ? 'Have an account?' : "Don't have an account?"}
        {' '}
        <button
          type="button"
          className="ai-sign-in-modal__switch-link cgt-body-md-semibold cgt-link-primary-accented"
          onClick={onSwitchMode}
        >
          {isSignup ? 'Log in' : 'Sign Up'}
        </button>
      </p>
    </div>
  )
}

Footer.propTypes = {
  isSignup: bool.isRequired,
  canSubmit: bool.isRequired,
  onSwitchMode: func.isRequired,
}

export default Footer
